/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewDomainsBlocklistRecord
 */
export interface CRSFSecReviewDomainsBlocklistRecord {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDomainsBlocklistRecord
     */
    asset: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDomainsBlocklistRecord
     */
    category: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDomainsBlocklistRecord
     */
    created: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDomainsBlocklistRecord
     */
    last_found: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDomainsBlocklistRecord
     */
    region: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDomainsBlocklistRecord
     */
    root_domain: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDomainsBlocklistRecord
     */
    service: string;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewDomainsBlocklistRecord
     */
    shared: boolean;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDomainsBlocklistRecord
     */
    source_list_name: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDomainsBlocklistRecord
     */
    subcategory: string;
}

/**
 * Check if a given object implements the CRSFSecReviewDomainsBlocklistRecord interface.
 */
export function instanceOfCRSFSecReviewDomainsBlocklistRecord(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "asset" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "last_found" in value;
    isInstance = isInstance && "region" in value;
    isInstance = isInstance && "root_domain" in value;
    isInstance = isInstance && "service" in value;
    isInstance = isInstance && "shared" in value;
    isInstance = isInstance && "source_list_name" in value;
    isInstance = isInstance && "subcategory" in value;

    return isInstance;
}

export function CRSFSecReviewDomainsBlocklistRecordFromJSON(json: any): CRSFSecReviewDomainsBlocklistRecord {
    return CRSFSecReviewDomainsBlocklistRecordFromJSONTyped(json, false);
}

export function CRSFSecReviewDomainsBlocklistRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewDomainsBlocklistRecord {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': json['asset'],
        'category': json['category'],
        'created': json['created'],
        'last_found': json['last_found'],
        'region': json['region'],
        'root_domain': json['root_domain'],
        'service': json['service'],
        'shared': json['shared'],
        'source_list_name': json['source_list_name'],
        'subcategory': json['subcategory'],
    };
}

export function CRSFSecReviewDomainsBlocklistRecordToJSON(value?: CRSFSecReviewDomainsBlocklistRecord | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': value.asset,
        'category': value.category,
        'created': value.created,
        'last_found': value.last_found,
        'region': value.region,
        'root_domain': value.root_domain,
        'service': value.service,
        'shared': value.shared,
        'source_list_name': value.source_list_name,
        'subcategory': value.subcategory,
    };
}

